export const AXIOSFALIED = "axios-failed";
